import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";
const PageNotFound = import("@/views/404");
const Login = import("@/views/login");
const Home = import("@/views/home/index");
const HomeMain = import("@/views/home/page/main");
const QuizMain = import("@/views/home/page/quiz");
const QuizDetail = import("@/views/home/page/quizdetail");
const QuizCountDown = import("@/views/home/page/quizcountdown");
const QuizSituation = import("@/views/home/page/quizsituation");
const ChapterMain = import("@/views/home/page/chapter");
const MaterialMain = import("@/views/home/page/material");
const AttendanceMain = import("@/views/home/page/attendance");
const PDFMain = import("@/views/home/page/pdf");
const Randomcall = import("@/views/home/page/randomcall");
const Followquestion = import("@/views/home/page/followquestion");
const Forum = import("@/views/home/page/forum");
const WhiteBoard = import("@/views/home/page/whiteboard");
const Vote = import("@/views/home/page/vote");
const Upload = import("@/views/home/page/upload");
const ForumDetail = import("@/views/home/page/forum_detail");
const ForumList = import("@/views/home/page/forum_list");
const ForumEdit = import("@/views/home/page/forum_edit");
Vue.use(Router);
// 解决重复push相同路由报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "loginPage",
      component: () => Login, // 路由懒加载写法
      meta: {
        title: "互动课堂"
      }
    },
    {
      path: "/home",
      // name: 'courseHome',
      component: () => Home,
      meta: {
        isLogin: true,
        title: "课程首页"
      },
      children: [
        {
          path: "/",
          name: "homeMain",
          meta: {
            title: "课程首页"
          },
          component: () => HomeMain
        },
        {
          path: "/quiz",
          name: "quizMain",
          meta: {
            title: "测验"
          },
          component: () => QuizMain
        },
        {
          path: "/quizdetail",
          name: "QuizDetail",
          meta: {
            title: "测验详情"
          },
          component: () => QuizDetail
        },
        {
          path: "/quizcountdown",
          meta: {
            title: "测验详情"
          },
          name: "QuizCountDown",
          component: () => QuizCountDown
        },
        {
          path: "/quizsituation",
          name: "QuizSituation",
          meta: {
            title: "测验答题情况"
          },
          component: () => QuizSituation
        },
        {
          path: "/material",
          meta: {
            title: "课堂资料"
          },
          name: "MaterialMain",
          component: () => MaterialMain
        },
        {
          path: "/chapter",
          name: "ChapterMain",
          meta: {
            title: "章节资料"
          },
          component: () => ChapterMain
        },
        {
          path: "/attendance",
          name: "AttendanceMain",
          meta: {
            title: "考勤"
          },
          component: () => AttendanceMain
        },
        {
          path: "/pdf",
          name: "PDFMain",
          meta: {
            title: "pdf文件预览"
          },
          component: () => PDFMain
        },
        {
          path: "/randomcall",
          name: "Randomcall",
          meta: {
            title: "随机点名"
          },
          component: () => Randomcall
        },
        {
          path: "/followquestion",
          name: "Followquestion",
          meta: {
            title: "随堂提问"
          },
          component: () => Followquestion
        },
        {
          path: "/forumList",
          name: "ForumList",
          meta: {
            title: "讨论区列表"
          },
          component: () => ForumList
        },
        {
          path: "/forum",
          name: "Forum",
          meta: {
            title: "讨论区"
          },
          component: () => Forum
        },
        {
          path: "/forum_edit",
          name: "ForumEdit",
          meta: {
            title: "讨论区"
          },
          component: () => ForumEdit
        },
        {
          path: "/forumDetail",
          name: "ForumDetail",
          meta: {
            title: "话题详情"
          },
          component: () => ForumDetail
        },
        {
          path: "/whiteboard",
          name: "WhiteBoard",
          meta: {
            title: "白板"
          },
          component: () => WhiteBoard
        },
        {
          path: "/upload",
          name: "Upload",
          meta: {
            title: "文件上传"
          },
          component: () => Upload
        },
        {
          path: "/vote",
          name: "Vote",
          meta: {
            title: "投票结果"
          },
          component: () => Vote
        }
      ]
    },
    { path: "*", component: () => PageNotFound }
  ]
});
// 导航前守卫(跳转前)
router.beforeEach((to, from, next) => {
  // to: 表示要跳转的页面。from:表示从哪个页面来
  let token = store.state.auth.userinfo.wstoken || "";
  // console.log(store.state);
  let mid = store.state.course.moduleId || 0;
  let require = to.matched.some(function(item) {
    // 是否需要登录
    return item.meta.isLogin;
  });
  if (!token && mid === 0 && require) {
    // 当未登录，且跳转的页面需要登录后才能操作时，进行路由拦截
    next({
      // 跳转登录页
      name: "loginPage",
      query: { redirect: to.fullPath } // 将要跳转（即被拦截）的路由对象，作为参数，传递到登录页面
    });
  } else {
    // 已登录就正常跳转，不做任何拦截
    next(); // 正常跳转到下一页
  }
});
// 导航后守卫(跳转后)
router.afterEach((to, from) => {
  document.title = to.meta.title || "互动课堂"; // 跳转后设置页面的title
});
export default router;
